const Impressum = () => {
  return (
    <div>
      <title>Impressum - Surfwetter</title>
      <div className="App">
        <div className="Content">
          <h2>Kontaktadresse</h2>
          <p>
            Roman Attinger
            <br />
            8103 Unterengstringen
            <br />
            Schweiz
            <br />
            <a href="mailto:info@surfwetter.ch">info@surfwetter.ch</a>
          </p>
          <h2>Haftungsausschluss</h2>
          <p>
            Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen
            Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und
            Vollständigkeit der Vorhersageinformationen. Haftungsansprüche gegen den Autor
            wegen Schäden materieller oder immaterieller Art, welche aus dem
            Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten
            Informationen, durch Missbrauch der Verbindung oder durch technische
            Störungen entstanden sind, werden ausgeschlossen. Alle Informationen sind
            unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der
            Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu
            verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise
            oder endgültig einzustellen.
          </p>
          <h2>Haftung für Links</h2>
          <p>
            Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres
            Verantwortungsbereichs Es wird jegliche Verantwortung für solche
            Webseiten abgelehnt. Der Zugriff und die Nutzung solcher Webseiten
            erfolgen auf eigene Gefahr des Nutzers oder der Nutzerin.
          </p>
          <h2>Urheberrechte</h2>
          <p>
            Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder
            anderen Dateien auf der Website gehören ausschliesslich
            surfwetter.ch oder den speziell genannten Rechtsinhabern. Für die
            Reproduktion jeglicher Elemente ist die schriftliche Zustimmung der
            Urheberrechtsträger im Voraus einzuholen.
          </p>
          <h2>Quelle</h2>
          <p>
            Dieses Impressum wurde am 11.08.2025 mit dem Impressum Generator der
            Webdesign Agentur{" "}
            <a href="https://webkoenig.ch/" target="_blank">
              Webkönig
            </a>{" "}
            erstellt. Die Agentur Webkönig übernimmt keine Haftung.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
